import { createApp } from 'vue';
import PefToJpgConverter from '../Components/PefToJpgConverter.vue';

const root = document.getElementById('pef-to-jpg-converter');
if (root) {
  createApp(PefToJpgConverter).mount('#pef-to-jpg-converter');
}
